import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function PhysicalStock_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/PhysicalStock" ? (
        <div>
          <span className="breadcrumb-not-active ">PhysicalStock </span>
        </div>
      ) : vPathName === "/PhysicalStockDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/PhysicalStock"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            PhysicalStock
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">PhysicalStockDetail </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default PhysicalStock_BreadCrumbs;
